import { getAuth, Auth } from "firebase/auth";
import { getFirebaseApp } from "./getFirebaseApp";
export function getFirebaseAuth(): Auth {
  return getAuth(getFirebaseApp());
}
